import { HeroImageBackgroundComponent } from '@/admins/SmartReports/components/Components/Images';
import type { ComponentViewProps } from '@/admins/SmartReports/components/Components/types';
import { LogoBox } from '@/admins/SmartReports/components/Layouts/components';
import { TitleBoxTypography } from '@/admins/SmartReports/components/Layouts/components/TitleBoxTypography';
import { SlotsEnum } from '@/admins/SmartReports/components/Layouts/TitlePage/types';
import { SlotView } from '@/admins/SmartReports/components/Slots/SlotView';
import { useGetPageComponent } from '@/admins/SmartReports/hooks/useGetPageComponent';
import type { SmartReportEntityExtended } from '@/admins/SmartReports/types';
import { WelligenceLogo } from '@/components/WelligenceLogo';
import type { SmartReportPage } from '@/types/GraphqlSchema';
import { styles } from './styles';

type TitlePageViewProps = {
  pageData: SmartReportPage;
  entity: SmartReportEntityExtended;
};

export const TitlePageView = ({ pageData, entity }: TitlePageViewProps) => {
  const { slotData: countryIsoCode } = useGetPageComponent(pageData, SlotsEnum.BackgroundImage);

  const BackgroundComponent = HeroImageBackgroundComponent.ComponentView as React.ComponentType<
    ComponentViewProps<string>
  >;
  return (
    <BackgroundComponent data={countryIsoCode} sx={styles.titlePageRoot}>
      <LogoBox sx={styles.logoBox}>
        <WelligenceLogo />
      </LogoBox>

      <TitleBoxTypography sx={styles.typography1}>
        <SlotView slotId={SlotsEnum.Title} entity={entity} pageData={pageData} />
      </TitleBoxTypography>
      <TitleBoxTypography sx={styles.typography2}>
        <SlotView slotId={SlotsEnum.Subtitle} entity={entity} pageData={pageData} />
      </TitleBoxTypography>

      <TitleBoxTypography sx={styles.typography3}>
        <SlotView slotId={SlotsEnum.Subtitle2} entity={entity} pageData={pageData} />
      </TitleBoxTypography>
    </BackgroundComponent>
  );
};
